const sidebar = {
  app: "Dashboard",
  OrderModel: "Orders",
  StateModel: "States",
  CitiModel: "Cities",
  OrderCreation: "New Order",
  DoctorModel: "Doctors",
  PatientModel: "Patients",
  OperatorModel: "Operators",
  LabActionCost: "Costs",
  LabModel: "Laboratories",
  UnitModel: "Clinics",
  UserModel: "Users",
  OrderStepModel: "Order Steps",
  LabStepModel: "Lab Steps",
  PlanModel: "Plan Model",
  ActionsModel: "Actions Model",

  doctors: "Doctors",
  patients: "Patients",
  services: "Services",
  units: "Units",
  labs: "Laboratories",
  ordersList: "Orders List",
  ordersList: "Orders List",
};
export default sidebar;
